import React from 'react';
import ReactDOM from 'react-dom';
import 'rc-drawer/assets/index.css';
import 'styles/bootstrap.scss'
import 'styles/app.scss';
import 'styles/app-rtl.scss';
import '../css/font-awesome/css/all.min.css';
import '../css/material-design-iconic-font/css/material-design-iconic-font.css';
import '../css/weather-icons/css/weather-icons-wind.css';
import '../css/animate.css';
import '../css/loader.css';
import '../css/react-notification/react-notifications.css';
import "react-datetime/css/react-datetime.css";
import '../css/main.scss';
import 'react-bootstrap-typeahead/css/Typeahead.min.css';
import "swagger-ui-react/swagger-ui.css";
import 'react-toastify/dist/ReactToastify.css';
import "prismjs"; //Prism is not defined
const rootEl = document.getElementById('app-site');

// Country and default themes are now loaded via <link> tags in admin_index.html,
// not via webpack require() — see webpack.config.js theme entries + admin/views.py.
// This lets deployments override individual themes/<slug>.css files with Docker
// volume mounts without rebuilding the GDB image.

// Create a reusable render method that we can call more than once
let render = () => {
    // Dynamically import our main App component, and render it
    const MainApp = require('./MainApp').default;
    ReactDOM.render(
        <MainApp/>,
        rootEl
    );
};

if (module.hot) {
    module.hot.accept('./MainApp', () => {
        const NextApp = require('./MainApp').default;
        render(
            <NextApp/>,
            rootEl
        );
    });
}

render();
